import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';

import Button from '@components/shared/Button';

const AnchorTabs = ({ anchors, label, className, onClick }) => (
  <div className={classNames('anchors', className)}>
    <ul className="anchors__list">
      {anchors &&
        anchors.map(anchor => (
          <li key={anchor[label]} className="anchors__item">
            <Button
              type="button"
              color="blue"
              title={anchor[label]}
              className="anchors__btn"
              onClick={() => onClick(anchor)}
            >
              {anchor[label]}
            </Button>
          </li>
        ))}
    </ul>
  </div>
);

AnchorTabs.defaultProps = {
  label: 'label',
  onClick: () => null
};

AnchorTabs.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  anchors: PropTypes.array,
  className: PropTypes.string
};

export default AnchorTabs;
